export interface ICommunicationTemplate {
	id: string;
	channel: CommunicationChannel;
	endpoint: CommunicationEndpoint;
	messageType: CommunicationMessageType;
	customName: string;
	html: string;
	isEnabled: boolean;
}

export enum CommunicationMessageType {
	ConfirmReservation = 'confirm-reservation',
	ConfirmLessonReservation = 'confirm-lesson-reservation',
	ConfirmBeegoAppointment = 'confirm-beego-appointment',
	CancelReservation = 'cancel-reservation',
	CancelLessonReservation = 'cancel-lesson-reservation',
	CancelBeegoAppointment = 'cancel-beego-appointment',
	ChangeReservation = 'change-reservation',
	ChangeLessonReservation = 'change-lesson-reservation',
	RemindReservation = 'remind-reservation',
	RemindLessonReservation = 'remind-lesson-reservation',
	RemindReturnLoan = 'remind-return-loan',
	InviteRatingReservation = 'invite-rating-reservation',
	CustomReservation = 'custom-reservation',
	CustomLessonReservation = 'custom-lesson-reservation',
	CustomBeegoAppointment = 'custom-beego-appointment',
	CustomLoan = 'custom-loan',
}

export enum CommunicationChannel {
	Email = 'email',
	// Notification = 'notification',
	Sms = 'sms',
}

export enum CommunicationEndpoint {
	User = 'user',
	Client = 'client',
	Employee = 'employee',
}
